<nav>
  <div class="nav flex wrap items-center g-9 justify-between">
    <div class="flex items-center g-9">
      <img
        [src]="themeService.getTheme() === 'dark' ? '../../../assets/images/logo-with-name-dark.svg' : '../../../assets/images/logo-with-name.svg'"
        alt="Sintegra Logo" routerLink="/home">
      <ul class="flex g-5">
        <li class="flex">
          <a routerLink="/home">{{ 'home' | translate }}</a>
        </li>
        <li class="flex">
          <a class="flex g-3" (click)="presentProductPopover()">
            <p #popoverTriggerProduct>{{ 'products' | translate }}</p>
            <ion-icon name="caret-down-outline"></ion-icon>
          </a>
          <ion-popover #popoverProduct [isOpen]="isOpenProduct" (didDismiss)="isOpenProduct = false">
            <ng-template>
              <ion-content class="ion-padding">
                <ul class="flex direction-col g-5">
                  <li class="submenu-item cursor-pointer" routerLink="/products" (click)="isOpenProduct = false">{{
                    'products' |
                    translate }}</li>
                  <li class="submenu-item cursor-pointer" routerLink="/instructions" (click)="isOpenProduct = false">{{
                    'instructions' |
                    translate }}</li>
                </ul>
              </ion-content>
            </ng-template>
          </ion-popover>
        </li>
        <li class="flex">
          <a class="flex g-3" (click)="presentPopover()">
            <p #popoverTrigger>{{ 'updates' | translate }}</p>
            <ion-icon name="caret-down-outline"></ion-icon>
          </a>
        </li>
        <ion-popover #popover [isOpen]="isOpen" (didDismiss)="isOpen = false">
          <ng-template>
            <ion-content class="ion-padding">
              <ul class="flex direction-col g-5">
                <li class="submenu-item cursor-pointer" routerLink="/procedures" (click)="isOpen = false">{{
                  'surgical.procedures' |
                  translate }}</li>
                <li class="submenu-item cursor-pointer" routerLink="/news" (click)="isOpen = false">{{ 'news' |
                  translate }}</li>
              </ul>
            </ion-content>
          </ng-template>
        </ion-popover>
        <li class="flex">
          <a routerLink="/events">{{ 'events' | translate }}</a>
        </li>
        <li class="flex">
          <a routerLink="/corporate">{{ 'corporate' | translate }}</a>
        </li>
        @if (user) {
        <li class="flex">
          <a routerLink="/favorites">{{ 'favorites' | translate }}</a>
        </li>
        }
      </ul>
    </div>
    <div class="flex items-center g-9">
      <ion-searchbar #searchbar class="custom" mode="ios" inputmode="search" [placeholder]="'search' | translate"
        (keyup.enter)="search($event)" show-clear-button="focus"></ion-searchbar>
      <div class="buttons flex items-center g-6">
        @if (!user && isLoaded) {
        <button class="login" [routerLink]="['/login']" routerLinkActive="router-link-active">{{ 'login' |
          translate }}</button>
        <button class="register" [routerLink]="['/login/register']" routerLinkActive="router-link-active">{{ 'register'
          | translate }}</button>
        }
        @if (user && isLoaded) {
        <img class="avatar" [src]="user.data.persons[0].picture" alt="User avatar"
          onerror="this.src='../../../assets/images/user.png'" [routerLink]="'/profile'">
        }
      </div>
    </div>
  </div>
</nav>
